module.exports = __webpack_public_path__ + "static/img/31_pro.942cf4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/31_pro.jpg
// module id = rgT2
// module chunks = 0